import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

// Import the `getField` getter and the `updateField`
// mutation function from the `vuex-map-fields` module.
import { getField, updateField } from "vuex-map-fields";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    canvas: {
      backgroundColor: "#FFFFFF",
      height: "",
      width: "",
      padding: 50
    },
    window: {
      actionStyle: "MacOS",
      showWindowButtons: true,
      showWindowTitle: true,
      width: "",
      height: "",
      showBorderRadius: true,
      borderRadiusTopLeft: "5",
      borderRadiusTopRight: "5",
      borderRadiusBottomRight: "5",
      borderRadiusBottomLeft: "5",
      showShadow: true,
      shadow: {
        offsetX: "0",
        offsetY: "20",
        blurRadius: "68",
        spreadRadius: "0",
        color: "rgba(0, 0, 0, 0.55)"
      }
    },
    editor: {
      modeSelected: "",
      showLinesNumbers: true,
      showHTMLPreview: false,
      themeSelected: {
        name: "seti",
        background: "#151718",
        color: "#CFD2D1"
      },
      font: {
        size: 16
      }
    }
  },
  getters: {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
    appVersion: (state) => {
      return state.packageVersion
    }
  },
  mutations: {
    // Add the `updateField` mutation to the
    // `mutations` of your Vuex store instance.
    updateField
  },
  actions: {},
  plugins: [createPersistedState()]
});
